import { keyBy } from "./index"
import { getProductPriceForDay } from './priceUtils';

const generateSubTotal = (prod) => {
    try {
        const { finalPrice, originalPrice } = getProductPriceForDay(prod);
        const price = parseFloat(finalPrice);
        const original = parseFloat(originalPrice || finalPrice);
        const qty = parseFloat(prod.qty)

        let extraTotal = 0
        let originalExtraTotal = 0
        prod.smartComposition?.forEach(item => {
            item.composition?.forEach(c => {
                if (c.extraChecked) {
                    extraTotal += (parseFloat(c.extraQty || 1) * parseFloat(c.extraPrice || 0))
                    originalExtraTotal += (parseFloat(c.extraQty || 1) * parseFloat(c.extraPrice || 0))
                }
            })
        })

        const total = price * qty + extraTotal
        const originalTotal = original * qty + originalExtraTotal

        return { total, originalTotal }
    } catch (e) {
        console.error('generateSubTotal', e)
        return { total: 0, originalTotal: 0 }
    }
}

export const calculateTotalOrder = ({ productsList = [], deliveryPrice = 0, discount = 0, extras = [], pickup, usedPoints = 0, config = {} }) => {
    try {
        let total = 0
        let totalSavings = 0
        const today = new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();

        extras?.forEach(e => total += e.amount)

        productsList?.forEach(p => {
            const { total: subTotal, originalTotal } = generateSubTotal(p)
            total += subTotal
            totalSavings += originalTotal - subTotal
            if (pickup && p.salePrices && p.salePrices[today]?.extraDiscount) {
                total -= parseFloat(p.salePrices[today].extraDiscount)
            }
        })

        if (deliveryPrice !== '' && deliveryPrice !== null && !pickup)
            total += parseFloat(deliveryPrice)

        if (discount !== '' && discount !== null)
            total -= parseFloat(discount)

        let pickupDiscount = 0;
        if (pickup && config.pickupDiscount) {
            pickupDiscount = total * (config.pickupDiscount / 100);
            total -= pickupDiscount;
        }

        if (usedPoints > 0) {
            total -= usedPoints
        }

        if (pickup && config.pickupDiscountRounding) {
            const roundedTotal = Math.round(total / config.pickupDiscountRounding) * config.pickupDiscountRounding;
            pickupDiscount += total - roundedTotal;
            total = roundedTotal;
        }

        return { total, pickupDiscount, totalSavings }
    } catch (e) {
        console.error('calculateTotalOrder', e)
        return { total: 0, pickupDiscount: 0, totalSavings: 0 }
    }
}

export const validateAdminOrder = (order, paymentMethods) => {
    const validation = {
        valid: true,
        messagges: []
    }

    if (order?.type === 'table') {
        if (!order?.tableId) {
            validation.valid = false
            validation.messagges.push('Seleccione mesa')
        }
    }
    // console.log('order?.address', order?.address)
    // console.log('order?.pickup', order?.pickup)
    // console.log('order?.type', order?.type)
    // console.log('order', order)
    if (!order?.address && !order?.pickup && order?.type !== 'table') {
        validation.valid = false
        validation.messagges.push('Seleccione dirección')
    }
    if (!order?.clientName && order?.type !== 'table') {
        validation.valid = false
        validation.messagges.push('Seleccione cliente')
    }
    if (paymentMethods?.length > 0 && order?.type !== 'table') {
        if (!order?.paymentMethod) {
            validation.valid = false
            validation.messagges.push('Seleccione método de pago')
        }
    }
    if (order?.productsList?.length === 0) {
        validation.valid = false
        validation.messagges.push('Seleccione al menos un producto')
    } else {
        const _validation = validateOrderProductList(order?.productsList)
        if (!_validation.valid) {
            validation.valid = false
            _validation.messagges?.forEach(message => {
                validation.messagges.push(message)
            })
        }
    }

    return validation
}


export const validateOrderProductList = (productsList = []) => {
    const validation = {
        valid: true,
        messagges: []
    }

    let _validation = {
        valid: true,
        severity: 'success',
        message: 'Success'
    }
    let stop = false
    productsList?.map(product => {
        if (stop)
            return null

        if (product.smartComposition) {
            const { smartComposition = [] } = product

            for (let l = 0; l < smartComposition.length && !stop; l++) {
                const prod = smartComposition[l]
                _validation = validateProduct(prod, _validation)
                stop = _validation.break

                const { variants = [] } = prod

                if (_validation.valid) {
                    // eslint-disable-next-line no-loop-func
                    prod?.composition?.some(item => {
                        let __validation = {}

                        if (item.optional && !item.checked)
                            return false

                        validateProduct(item, __validation)
                        if (__validation.valid === false) {
                            const variant = variants.find(v => ((v.variantGroup || '').trim() || 'OPCIÓN') === ((item.variantGroup || '').trim() || 'OPCIÓN'))
                            // busco si para el mismo variantGroup ya hay otro elemento seleccionado
                            if (variant && variant?.variantId !== item.id)
                                return false
                            _validation = __validation
                        }
                        return __validation.valid
                    })
                }
            }

        } else {
            _validation = validateProduct(product, _validation)
            stop = _validation.break
        }

        return null
    })

    if (!_validation.valid) {
        validation.valid = false
        validation.messagges.push(_validation.message)
    }


    return validation
}

const validateProduct = (product, validation) => {
    const { composition = [], variants = [] } = product
    const variantsGrouped = keyBy(composition.filter(v => v.variant), v => (v.variantGroup || '').trim() || 'OPCIÓN')
    const variantsGroupedSelected = keyBy(variants, v => (v.variantGroup || '').trim() || 'OPCIÓN')


    // console.log('validateProduct', product)
    // console.log('variantsGrouped', variantsGrouped)
    // console.log('variantsGroupedSelected', variantsGroupedSelected)


    Object.keys(variantsGrouped).forEach(variantGroup => {
        const _variantGroup = variantGroup
        if (!variantsGroupedSelected[_variantGroup]) {
            validation.valid = false
            validation.severity = 'warning'
            validation.message = `No se ha seleccionado ${_variantGroup} para ${product.name || product.description}`
            validation.break = true
        }
    })

    return validation
}